var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaintTrackingMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5400_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8478 2.69678H1.15315C0.516488 2.69678 0.000488281 3.21278 0.000488281 3.84944V24.2134C0.000488281 24.8501 0.516488 25.3661 1.15315 25.3661H20.0232V28.1488C20.0232 28.8434 20.5918 29.3034 21.1838 29.3034C21.4672 29.3034 21.7558 29.1981 21.9905 28.9634L25.5878 25.3661H30.8472C31.4838 25.3661 31.9998 24.8501 31.9998 24.2134V3.84944C32.0005 3.21278 31.4845 2.69678 30.8478 2.69678ZM30.6672 24.0328H25.0365L21.3565 27.7128V24.0334H1.33382V4.03011H30.6672V24.0328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6672 8.03011H15.3338V16.0301H16.6672V8.03011Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6672 18.6968H15.3338V20.0301H16.6672V20.0301V18.6968Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5400_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintTrackingMenu);
export default __webpack_public_path__ + "static/media/complaint_tracking_menu.7b7d900406e0050ac80bcd8f90d1ac43.svg";
export { ForwardRef as ReactComponent };